import { Injectable, inject } from '@angular/core';
import { IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { IModelDataV3, Model } from '@df/catalog/model';
import { Meta } from '@df/core/meta/meta';
import { MultisiteService } from '@df/core/service/multisite';
import { ICmsPage } from '@icms/core/resource/page/icms-page';

const SUFFIX = ' | Oliver Bonas';

// TODO: (iCMS) fix page additional data
@Injectable({
    providedIn: 'root'
})
export class MetaDecorator extends Meta {
    protected multisite = inject(MultisiteService);

    override getMetaProperty(attr: string, model?: Model<IModelDataV3>) {
        if (attr === 'title') {
            const modelToCheck = model || this.model;

            if (modelToCheck?.data?.type === ICmsPage.type) {
                const page = modelToCheck as ICmsPage<IPageDataV3>;
                const title = page.data?.meta?.title || page.data?.name;

                if (title?.indexOf(SUFFIX) === -1 && !page.data?.typeData?.hide_meta_title_suffix) {
                    return title + SUFFIX + this.getStoreSuffix();
                }
            }
        }

        return super.getMetaProperty(attr, model);
    }

    protected getStoreSuffix(): string {
        const currentStore = this.multisite.current;

        if (currentStore?.siteId) {
            const siteId = currentStore.siteId.toLowerCase();

            if (siteId === 'us' || siteId === 'ie') {
                return ` ${siteId.toUpperCase()}`;
            }
        }

        return '';
    }
}
